import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Routes, Route, useNavigate } from "react-router-dom";

import Textiles from "../../pages/ProductCategories/RecreationalProducts";
import Sportswear from "../../pages/ProductCategories/Sportswear";
import PointOfSale from "../../pages/ProductCategories/PointOfSale";
import DisplaySignage from "../../pages/ProductCategories/LaundrySheets";
import Electronics from "../../pages/ProductCategories/Electronics";
import foodPack from "../../Assets/prodduct_categories/1.png";
import sportsWear from "../../Assets/prodduct_categories/2.png";
import recreation from "../../Assets/prodduct_categories/3.png";
import corporate from "../../Assets/prodduct_categories/4.png";
import electronics from "../../Assets/prodduct_categories/5.png";
import pets from "../../Assets/prodduct_categories/6.png";
import neon from "../../Assets/prodduct_categories/8.png";
import garment from "../../Assets/prodduct_categories/garment.png";
import vinyl from "../../Assets/prodduct_categories/9.png";
import kitchen from "../../Assets/prodduct_categories/10.png";
import sheets from "../../Assets/prodduct_categories/11.png";
import bags from "../../Assets/prodduct_categories/12.png";
import eco from "../../Assets/prodduct_categories/eco.png";


import "./Products.scss";

function ProductCategories() {
  const navigate = useNavigate();

  const products = [
    {
      title: "Cases & Bags",
      image: bags,
      // link: "/product_categories/textiles",
    },
    {
      title: "Custom Sportswear",
      image: sportsWear,
      // link: "/product_categories/sportswear",
    },
    {
      title: "Eco Friendly Products",
      image: eco,
      // link: "/product_categories/point-of-sale",
    },
    {
      title: "Recreational Products",
      image: recreation,
      // link: "/product_categories/display-signage",
    },
    {
      title: "Corporate Gifts",
      image: corporate,
      // link: "/product_categories/promotional-products",
    },
    {
      title: "Electronics Products",
      image: electronics,
      // link: "/product_categories/electronics",
    },
    {
      title: "Textiles & Garment",
      image: garment,
      // link: "/product_categories/electronics",
    },
    {
      title: "Pets Toys",
      image: pets,
      // link: "/product_categories/gym-fitness",
    },
    {
      title: "Food Packaging",
      image: foodPack,
      // link: "/product_categories/gym-fitness",
    },
    {
      title: "Neon Light",
      image: neon,
      // link: "/product_categories/gym-fitness",
    },
    {
      title: "Vinyl Flooring",
      image: vinyl,
      // link: "/product_categories/gym-fitness",
    },
    {
      title: "Kitchen Fit Outs ",
      image: kitchen,
      // link: "/product_categories/gym-fitness",
    },
    {
      title: "Laundry Detergent Sheets",
      image: sheets,
      // link: "/product_categories/gym-fitness",
    }

  ];

  return (
    <Container fluid className="page-top-settings">
      <Container className="product_categories">
        <Routes>
          {/* Define Routes for Individual Pages */}
          <Route path="textiles" element={<Textiles />} />
          <Route path="sportswear" element={<Sportswear />} />
          <Route path="point-of-sale" element={<PointOfSale />} />
          <Route path="display-signage" element={<DisplaySignage />} />
          <Route path="electronics" element={<Electronics />} />

          {/* Default Route: Display Product Grid */}
          <Route
            path="/"
            element={
              <>
                <h2 className="page-title">Product Categories
                  <p>Explore Our Sourcing Expertise
                  </p>
                </h2>
                <p className="mb-3">
                At Funda Sourcing, we pride ourselves on our ability to source a wide variety of products to meet the unique needs of every industry. With our proven process, robust infrastructure, and extensive global network, we ensure that no matter what product you're looking for, we can deliver with efficiency, quality, and cost-effectiveness. 
                </p>
                <p className="mb-5">
                  Below are some of the key categories of products we specialize in sourcing:
                </p>
                <Row>
                  {products.map((product, index) => (
                    <Col key={index} md={3} className="mb-4">
                      <Card
                        className="product-card"
                        onClick={() => navigate(product.link)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="image-container">
                          <Card.Img
                            variant="top"
                            src={product.image}
                            alt={product.title}
                          />
                        </div>
                        <Card.Body className="d-flex align-items-center justify-content-center">
                          <Card.Title className="text-center">
                            {product.title}
                          </Card.Title>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </>
            }
          />
        </Routes>
      </Container>
    </Container>
  );
}

export default ProductCategories;
